import { FileText, Hash, Package } from 'lucide-react'
import React from 'react'

import { usePalletActions } from '../../stores/palletStore'

import { PendingPallet } from '@/services/InboundV2Service'

interface PalletCardProps {
  pallet: PendingPallet
}

const PalletCard: React.FC<PalletCardProps> = ({ pallet }) => {
  const isMultipleMarks = pallet.cargoMarks.length > 1

  const { showPrintDialog, showDismantleContrim } = usePalletActions()

  return (
    <div className="py-2 px-3 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100 last:border-b-0">
      {/* 主要信息行 */}
      <div className="flex items-center justify-between mb-1.5">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <Hash className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
          <span className="font-medium text-gray-900 text-sm truncate">
            {pallet.palletCode}
          </span>
        </div>

        {/* 操作按钮 */}
        <div className="flex gap-1.5 flex-shrink-0">
          <button
            onClick={() => showPrintDialog(pallet)}
            className="px-2 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 transition-colors duration-150 flex items-center gap-1"
          >
            <FileText className="w-3 h-3" />
            <span>补打</span>
          </button>

          {pallet.canDisassemble && (
            <button
              onClick={() => showDismantleContrim(pallet.id)}
              className="px-2 py-1 bg-red-600 text-white rounded text-xs hover:bg-red-700 transition-colors duration-150"
            >
              拆托
            </button>
          )}
        </div>
      </div>

      {/* 详细信息行 */}
      <div className="flex items-center justify-between text-xs text-gray-600">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1">
            <Package className="w-3 h-3 text-gray-400" />
            <span>箱数: {pallet.totalBoxes}</span>
          </div>
          {isMultipleMarks ? (
            <div className="flex flex-col gap-1">
              {pallet.cargoMarks.map((mark) => (
                <div key={mark.id} className="flex items-center gap-1">
                  <Hash className="w-3 h-3 text-gray-400" />
                  <span>
                    <span className="font-semibold">{mark.markCode}</span>
                    <span className="text-gray-500"> ({mark.totalBoxes}箱)</span>
                  </span>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default PalletCard
